"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageMogr2 = void 0;
var tslib_1 = require("tslib");
var isObject_1 = tslib_1.__importDefault(require("lodash/isObject"));
var core_1 = require("@jsmodules/core");
var ImageMogr2Creater = new core_1.Pipeline();
var ImageMogr2 = /** @class */ (function () {
    function ImageMogr2(download_url, default_host, hosts) {
        if (hosts === void 0) { hosts = []; }
        this.download_url = download_url;
        this.default_host = default_host;
        this.hosts = hosts;
        this.options = {};
        this.autoOrient();
        ImageMogr2.Creater.execSync(this);
    }
    ImageMogr2.prototype.thumbnailScale = function (options) {
        var scaleType = options.scale_type;
        if (!scaleType) {
            scaleType = "default";
        }
        if (scaleType == "default") {
            return "!" + options.scale + "p";
        }
        else if (scaleType == "width") {
            return "!" + options.scale + "px";
        }
        else if (scaleType == "height") {
            return "!x" + options.scale + "p";
        }
        return null;
    };
    ImageMogr2.prototype.thumbnail = function (options) {
        this.options.thumbnail = this.options.thumbnail || {};
        var expr;
        if (options.scale) {
            expr = this.thumbnailScale(options);
            this.options.thumbnail["scale"] = expr;
            return this;
        }
        //指定目标图片宽度为 Width，高度等比压缩。
        if (options.width && !options.height) {
            this.options.thumbnail["wh"] = (options.width || "") + "x";
            return this;
        }
        //指定目标图片高度为 Height，宽度等比压缩。
        if (!options.width && options.height) {
            this.options.thumbnail["wh"] = "x" + (options.width || "");
            return this;
        }
        //忽略原图宽高比例，指定图片宽度为 Width，高度为 Height ，强行缩放图片，可能导致目标图片变形。
        if (options.width && options.height) {
            this.options.thumbnail["wh"] = options.width + "x" + options.height + "!";
            return this;
        }
        //限定缩略图的宽度和高度的最大值分别为 Width 和 Height，进行等比缩放。
        if (options.maxWidth || options.maxHeight) {
            this.options.thumbnail["max"] = (options.maxWidth || "") + "x" + (options.maxHeight || "");
            return this;
        }
        //限定缩略图的宽度和高度的最小值分别为 Width 和 Height，进行等比缩放。
        if (options.minWidth || options.minHeight) {
            this.options.thumbnail["min"] = "!" + (options.minWidth || "") + "x" + (options.minHeight || "") + "r";
            return this;
        }
        //等比缩放图片，缩放后的图像，总像素数量不超过 Area。
        if (options.area) {
            this.options.thumbnail["area"] = options.area + "@";
        }
        return this;
    };
    ImageMogr2.prototype.cut = function (width, height, dx, dy) {
        this.options.cut = width + "x" + height + "x" + dx + "x" + dy;
        return this;
    };
    ImageMogr2.prototype.crop = function (width, height) {
        if (!width && !height) {
            return this;
        }
        this.options.crop = (width || "") + "x" + (height || "");
        return this;
    };
    ImageMogr2.prototype.iradius = function (radius) {
        this.options.iradius = radius;
        return this;
    };
    ImageMogr2.prototype.scrop = function (width, height) {
        this.options.scrop = width + "x" + height;
        return this;
    };
    ImageMogr2.prototype.gravity = function (gravity) {
        this.options.gravity = gravity;
        return this;
    };
    ImageMogr2.prototype.rotate = function (deg) {
        this.options.rotate = deg;
        return this;
    };
    ImageMogr2.prototype.autoOrient = function () {
        this.options["auto-orient"] = true;
        return this;
    };
    ImageMogr2.prototype.format = function (format) {
        if (format) {
            this.options.format = format;
        }
        else {
            this.options.format = null;
        }
        return this;
    };
    ImageMogr2.prototype.cgif = function (frameNumber) {
        this.options.cgif = frameNumber;
        return this;
    };
    ImageMogr2.prototype.quality = function (quality, force) {
        if (force === void 0) { force = false; }
        this.options.quality = "" + quality + (force ? "!" : "");
        return this;
    };
    ImageMogr2.prototype.rquality = function (quality) {
        this.options.rquality = quality;
        return this;
    };
    ImageMogr2.prototype.lquality = function (quality) {
        this.options.lquality = quality;
        return this;
    };
    ImageMogr2.prototype.blur = function (radius, sigma) {
        if (sigma <= 0) {
            return this;
        }
        this.options.blur = radius + "x" + sigma;
        return this;
    };
    ImageMogr2.prototype.sharpen = function (value) {
        if (value >= 10 && value <= 300) {
            this.options.sharpen = value;
        }
        return this;
    };
    ImageMogr2.prototype.getQuery = function (hasQuery) {
        if (hasQuery === void 0) { hasQuery = false; }
        var options = [];
        for (var key in this.options) {
            var val = this.options[key];
            if (val === true) {
                options.push("/" + key);
            }
            else if (isObject_1.default(val)) {
                for (var item in val) {
                    var itemVal = val[item];
                    options.push("/" + key + "/" + itemVal);
                }
            }
            else if (val) {
                options.push("/" + key + "/" + val);
            }
        }
        if (options.length == 0) {
            return "";
        }
        var prefix = "?";
        if (hasQuery) {
            prefix = "&";
        }
        return prefix + "imageMogr2" + options.join("");
    };
    /**
     * 获取url
     */
    ImageMogr2.prototype.getURL = function () {
        var e_1, _a;
        if (!this.download_url) {
            return null;
        }
        if (/^file:\/\//.test(this.download_url)) {
            return this.download_url;
        }
        if (/\.gif$/.test(this.download_url)) {
            //强行将gif转换为16
            this.options = [];
            // this.cgif(20);
        }
        var hasQuery = false;
        if (this.download_url.indexOf("?") != -1) {
            hasQuery = true;
        }
        if (/^\/\//.test(this.download_url) || /^https?:\/\//.test(this.download_url)) {
            try {
                for (var _b = tslib_1.__values(this.hosts), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var h = _c.value;
                    if (this.download_url.indexOf(h) != -1) {
                        return "" + this.download_url + this.getQuery(hasQuery);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return this.download_url;
        }
        var path = this.download_url.replace(/^\//, "");
        return this.default_host + "/" + path + this.getQuery(hasQuery);
    };
    /**
     * 获取url
     * @deprecated
     */
    ImageMogr2.prototype.render = function () {
        return this.getURL();
    };
    ImageMogr2.src = function (url, host, hosts) {
        return new ImageMogr2(url, host, hosts);
    };
    ImageMogr2.Creater = ImageMogr2Creater;
    return ImageMogr2;
}());
exports.ImageMogr2 = ImageMogr2;
exports.default = ImageMogr2;
